import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function DonutIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M15.228 10.857a3.6 3.6 0 0 0 -0.785 -1.299 3.086 3.086 0 0 0 -1.272 -0.814V0.629q4.087 0.398 6.958 3.271 2.87 2.873 3.271 6.957zm-4.342 12.514q-4.401 -0.429 -7.342 -3.686T0.6 12t2.943 -7.685T10.886 0.629V8.743q-1.029 0.37 -1.658 1.272 -0.627 0.9 -0.627 1.985t0.627 1.958 1.658 1.243zm2.285 0V15.201q0.744 -0.257 1.272 -0.787 0.528 -0.528 0.785 -1.27h8.172q-0.399 4.085 -3.271 6.957t-6.958 3.271"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
